import React from 'react';
import { Grid, Typography } from '@material-ui/core';
import './VisitFeedbackThankYouPage.scss';
import { useTranslation } from 'react-i18next';

const VisitFeedbackThankYouPage = () => {
  const [t] = useTranslation();
  return (
    <main className="VisitFeedbackThankYouPage container">
      <Grid container spacing={2}>
        <Grid item xs={12}>
          <Typography variant="h4" component="h1">
            {t('ThankYouPage.thankYou')}
          </Typography>
        </Grid>

        <Grid item xs={12} sm={8}>
          <span> {t('ThankYouPage.thankYouFeedbackReview')} </span>
        </Grid>
      </Grid>
    </main>
  );
};

VisitFeedbackThankYouPage.propTypes = {};

export default VisitFeedbackThankYouPage;
